(function($){
    $('.collapsible .question').click(function(){
        var $parent = $(this).parent(),
            $this = $(this);
        if(!$parent.hasClass('open') && $this.closest('.collapsible-group').hasClass('exclusive')){
            $parent.siblings().removeClass('open');
        }
        $parent.toggleClass('open');
    });
})(jQuery);